import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AddBlock } from '@lyearn/molecules';
import { Loader, Stack } from '@lyearn/ui';
import { FilterOption } from '@/components/Filter/types';
import { Filter } from '@/components/FilterManager';
import { PeerFeedbackSkillRatingInputType } from '@/types/schema';

import useCreateFeedbackRelatedSkills from '../../../hooks/useCreateFeedbackRelatedSkills';
import ReviewCardList from '../../ReviewCardList';
import { AddBlockStyles, MENU_LIST_OVERRIDES } from '../style';
import { SkillItemRenderer } from '../utils';

function RelatedMindsets({
  onChange,
  skillRatings,
  userId,
}: {
  onChange: (value: PeerFeedbackSkillRatingInputType[]) => void;
  skillRatings: PeerFeedbackSkillRatingInputType[];
  userId?: string;
}) {
  const { t } = useTranslation(['Feedback', 'Skills']);
  const {
    selectedSkillsState,
    filterGroups,
    fetching,
    skillRatingMap,
    onRatingChange,
    searchText,
    setSearchText,
    toggle,
    open,
    removeSkill,
    addSkill,
  } = useCreateFeedbackRelatedSkills({
    userId,
    skillRatings,
    onChange,
  });

  return (
    <Stack direction="col">
      {fetching ? (
        <Stack alignItems="center" className="mb-16 flex-1" justifyContent="center">
          <Loader />
        </Stack>
      ) : (
        <ReviewCardList
          feedbackSkillData={skillRatingMap}
          removeSkill={removeSkill}
          skills={selectedSkillsState || []}
          onChange={onRatingChange}
        />
      )}
      <Filter
        asyncOptions={{
          search: {
            placeholder: t('Skills:Skill.SearchSkills'),
            value: searchText,
            onChange: setSearchText,
          },
        }}
        emptyLabel={userId ? t('Feedback:NoSkillsDesc') : t('Feedback:NoUserSelectedSkillsDesc')}
        groups={filterGroups}
        itemRenderer={SkillItemRenderer}
        open={open}
        overrides={MENU_LIST_OVERRIDES}
        showActionButtons={false}
        value={(selectedSkillsState || []) as FilterOption[]}
        onChange={addSkill}
        onClose={toggle}
        onToggle={toggle}>
        <AddBlock className={AddBlockStyles} title={t('Feedback:CreateFeedback.Skill.AddSkills')} />
      </Filter>
    </Stack>
  );
}

export default RelatedMindsets;
